/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="15.36"
        height="19"
        viewBox="0 0 15.36 19"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M7.68 19c3.57 0 7.68-.57 7.68-5 0-3-2-7-5.14-8.55L11.7.95l-.4-.19a9.54 9.54 0 0 0-7.27 0l-.41.18 1.49 4.53C1.95 6.99 0 11.06 0 14c0 4.43 4.1 5 7.68 5ZM4.86 1.5a8.69 8.69 0 0 1 5.61 0L9.29 5.09a5.18 5.18 0 0 0-.66-.14h-1.9c-.25 0-.49.08-.74.14Zm2.09 4.42h1.52a5.13 5.13 0 0 1 1.21.37l.26.12a9.37 9.37 0 0 1 4.46 7.58c0 2.83-2 4-6.68 4s-6.68-1.21-6.68-4C1 9.6 4.53 6.27 6.95 5.89Zm-1 7.6-.11-.1-.7.71.11.11a3.46 3.46 0 0 0 2 .94v.79h1v-.78a2.35 2.35 0 0 0 1.39-.63 1.58 1.58 0 0 0 .44-1.2c0-1.25-1.15-1.6-1.83-1.77v-1.58a2.14 2.14 0 0 1 1 .48l.1.1.75-.66-.1-.11a3 3 0 0 0-1.76-.85v-.82h-1v.82a2.1 2.1 0 0 0-1.34.58 1.54 1.54 0 0 0-.43 1.17c.05 1 .9 1.41 1.76 1.65v1.81a2.39 2.39 0 0 1-1.3-.66Zm2.3-.89c.69.22.82.43.83.77a.59.59 0 0 1-.16.47 1.38 1.38 0 0 1-.67.31Zm-1.76-2a.58.58 0 0 1 .16-.43 1 1 0 0 1 .6-.27v1.35c-.7-.22-.77-.43-.78-.64Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'BagWithDollarSignIcon';

export default Icon;
